export default __webpack_public_path__ + "static/media/App.f6da4820.png";